import { LogOut } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

type UserLike =
  | {
      display_name?: string;
      identifier?: string;
      metadata?: Record<string, unknown>;
    }
  | null
  | undefined;

type Props = {
  user: UserLike;
  onLogout: () => void;
};

export default function AccountSection({ user, onLogout }: Props) {
  const displayName = user?.display_name || user?.identifier || '—';
  const identifier = user?.identifier;
  const email =
    typeof user?.metadata?.email === 'string'
      ? (user.metadata.email as string)
      : undefined;

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader title="Account" blurb="Signed-in profile and session actions." />
      <Card>
        <CardContent className="p-4 flex flex-col gap-2 text-sm">
          <Row label="Name" value={displayName} />
          {identifier && identifier !== displayName && (
            <Row label="Username" value={identifier} />
          )}
          {email && <Row label="Email" value={email} />}
        </CardContent>
      </Card>
      <Button variant="destructive" className="w-full" onClick={onLogout}>
        <LogOut className="h-4 w-4 mr-2" />
        Sign out
      </Button>
    </div>
  );
}

function SectionHeader({ title, blurb }: { title: string; blurb: string }) {
  return (
    <div className="flex flex-col gap-1">
      <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      <p className="text-xs text-muted-foreground">{blurb}</p>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-foreground truncate">{value}</span>
    </div>
  );
}
